import React, { Fragment } from 'react'
import Card from '@material-ui/core/Card'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'

import Title from '../Generic/Title'
import OptionsIcon from '@material-ui/icons/Build'

import Button from '@material-ui/core/Button'
import { Link } from 'react-router-dom'

const items = [
    {name : 'Grupos', path : 'grupos'},
    {name : 'Empresas', path : 'empresas'},
    {name : 'Decretos', path : 'decretos'},
    {name : 'Categorias Vida Útil', path : 'categorias-vida-util'},
    {name : 'Sistemas Interconectados', path : 'sistemas-interconectados'},
    {name : 'Sistemas Eléctricos', path : 'sistemas-electricos'},
    {name : 'Comunas', path : 'comunas'},
    {name : 'Provincias', path : 'provincias'},
    {name : 'Regiones', path : 'regiones'},
]


export const MantenedorList = props => (
    <Fragment>
        <Title title={"Mantenedor"} icon={<OptionsIcon />} />
        <Card>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>
                            Nombre
                        </TableCell>
                        <TableCell />
                    </TableRow>
                </TableHead>
                <TableBody>
                    {items.map(row => (
                        <TableRow key={row.path}>
                            <TableCell>{row.name}</TableCell>
                            <TableCell>
                                <Button
                                    size="small"
                                    color="primary"
                                    component={Link}
                                    to={{pathname: `/${row.path}`}}
                                    // className={classes.link}
                                >
                                    Ver Registros
                                </Button>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </Card>
    </Fragment>
)